import isNil from "ramda/es/isNil";
import unless from "ramda/es/unless";
/**
 * Remove diacritics
 *
 * @documented
 * @category String
 *
 * @param {String} text for removing diacritics
 * @example
 *
 *     removeDiacritics('Žluťoučký') // => 'Zlutoucky'
 *
 */ const removeDiacritics = (text)=>{
    return unless(isNil, (t)=>t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))(text);
};
export default removeDiacritics;
